// extracted by mini-css-extract-plugin
module.exports = {"header":"header_index_header__17NM0","img":"header_index_img__cC09d","content":"header_index_content__21-mr"};